var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "问答",
        width: 800,
        visible: _vm.visible,
        "ok-button-props": { props: { disabled: true } },
        confirmLoading: _vm.confirmLoading
      },
      on: { cancel: _vm.handleCancel }
    },
    [
      _c("div", [
        _c(
          "div",
          { staticClass: "chat-history" },
          _vm._l(_vm.messages, function(message, index) {
            return _c(
              "div",
              {
                key: index,
                class: { user: message.isUser, bot: !message.isUser }
              },
              [_c("span", [_vm._v(_vm._s(message.text))])]
            )
          }),
          0
        ),
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.sendMessage($event)
              }
            }
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.userInput,
                  expression: "userInput"
                }
              ],
              staticStyle: { width: "94%" },
              attrs: {
                type: "text",
                placeholder: "输入您的问题",
                required: ""
              },
              domProps: { value: _vm.userInput },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.userInput = $event.target.value
                }
              }
            }),
            _c(
              "button",
              {
                staticStyle: { color: "white", "background-color": "#3260c9" },
                attrs: { type: "submit" }
              },
              [_vm._v("发送")]
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }